import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { CLIENT_ADMIN, SUPER_ADMIN } from '~/constants/roles'

const INTERNAL_EMAIL_DOMAINS = ['@ecto.digital', '@ecto.com.br']

const getUserRole = role => {
  if (role === SUPER_ADMIN) return 'super_admin'
  if (role === CLIENT_ADMIN) return 'client_admin'
  return 'client'
}

const ClarityScript = () => {
  const profile = useSelector(state => state.user?.profile)

  useEffect(() => {
    const clarityId = process.env.REACT_APP_CLARITY_ID
    if (!clarityId) return

    const script = document.createElement('script')
    script.innerHTML = `(function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${clarityId}");`
    document.head.appendChild(script)
  }, [])

  useEffect(() => {
    if (!process.env.REACT_APP_CLARITY_ID || !profile) return
    if (typeof window.clarity !== 'function') return

    const email = (profile.email || '').toLowerCase()
    const isInternal = INTERNAL_EMAIL_DOMAINS.some(domain =>
      email.endsWith(domain)
    )

    window.clarity('set', 'user_type', isInternal ? 'internal' : 'external')
    window.clarity('set', 'user_role', getUserRole(profile.role))

    if (profile.account?.id) {
      window.clarity(
        'set',
        'user_org',
        `${profile.account.id} | ${profile.account.name}`
      )
    }
  }, [profile])

  return null
}

export default ClarityScript
